<template> 
<div id="step_component_wrapper">            
    <clip-loader :loading="loading" :color="'rgb(93, 197, 150)'" size="56px"></clip-loader>

    <div v-if="!loading" class="slot-content">
        <v-select v-if="categoriesObjects.length > 0" label="des" :options="categoriesObjects" v-model="categoria" :categoryModel="true"
            :placeholder="$Jed.firstUpperTranslate('select a %1$s from the list below', null, {key: 'category'}, 'female')"
            :selectStyle="{'background-color': 'white', 'border-radius': '4px'}"
            :tagStyle="{'background-color': '#5897fb', color: 'white', padding: '3px'}"
            :menuStyle="{position: 'relative', 'max-height': '150px'}"
            :activeStyle="{'background-color': '#5897fb', color: 'white'}"
            :highStyle="{'background-color': '#ccc', color: 'white'}">
        </v-select>  
        <label v-else>{{$Jed.firstUpperTranslate('A problem occurred in loading %1$s', null, {key: 'category', n: 2}, 'female')}}</label><br>
        <v-select label="des" :options="models" v-model="modello" 
            :placeholder="$Jed.firstUpperTranslate('select a %1$s from the list below', null, {key: 'model'}, 'male')"
            :selectStyle="{'background-color': 'white', 'border-radius': '4px'}"
            :tagStyle="{'background-color': '#5897fb', color: 'white', padding: '3px'}"
            :menuStyle="{position: 'relative', 'max-height': '150px'}"
            :activeStyle="{'background-color': '#5897fb', color: 'white'}"
            :highStyle="{'background-color': '#ccc', color: 'white'}"
            style="margin-top: 25px">
        </v-select>
        <!--<label v-else>{{$Jed.firstUpperTranslate('A problem occurred in loading %1$s', null, {key: 'model', n: 2}, 'male')}}</label>-->
    </div>
    <div v-if="!loading" class="slot-button">
        <button v-if="!backTo1Allowed" class="btn btn-danger" @click="$root.logout()">Logout</button>
        <button v-else class="btn btn-danger" @click="$emit('backward')">{{$Jed.firstUpperTranslate('back', null)}}</button>

        <button v-if="step7" class="btn btn-primary-default" @click="forward" :disabled="modello == null">{{$Jed.firstUpperTranslate('confirm', null)}}</button>
        <button v-else class="btn btn-success" @click="load" :disabled="modello == null" style="width: auto;">{{$Jed.firstUpperTranslate('load', null)}}</button>
    </div>
</div> 
</template>
<script>
import vSelect from "../../dynamic/vueSelectWrapper/components/Select.vue"
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

export default {
    props: {
        catalogo: String,
        backTo1Allowed: {
            type: Boolean,
            default: false
        }
    },
    mounted: function(){
        this.nodes_coll = this.$root.dbModels.getCollection('nodes');
        this.products_coll = this.$root.dbModels.getCollection('products');
        this.trans_coll = this.$root.dbModels.getCollection("translations");
        this.init();
    },
    data: function(){
        return {
            loading: true,
            categories: [],
            categoriesObjects: [],
            categoria: null,
            modelsView: null,
            models: [],
            modelsTranslation: {},
            modello: null,
            products_coll: null,
            nodes_coll: null,
            trans_coll: null,
            //step7: this.$Behaviors.requestUpdateReference && !this.$Behaviors.machineIdMustExists
            step7: !this.$Behaviors.machineIdMustExists
        }
    },
    components : {
        ClipLoader,
        vSelect
    },
    watch: {
        categoria: function(cat){ //quando cambia la categoria, carico i suoi modelli nell'altro dropdown
            this.$nextTick(function(){
                if(cat){
                    this.models = this.modelsView.branchResultset('singleCategoryTransform', {category: cat.fid}).data();
                } else {
                    this.models = this.modelsView.data({forceClones: true});
                }
                this.fetchTranslations();
            })
        }
    },
    methods: {
        backward: function() {
            var parameters = {step: 5};
            this.$emit("forward", parameters);
        },
        forward: function() {
            var vm = this;
            var m = vm.modello.sid;
            var c = vm.modello.fid;
            var d = vm.modello.des;

            vm.$store.commit('setModel', m)
            vm.$store.commit('setCategory', c)
            
            var parameters = {step: 7};
            parameters.override = {modello: m, categoria: c, descrizioneModello: d}
            vm.$emit("forward", parameters);
        },
        load: function(){
            var vm = this;
            var m = vm.modello.sid;
            var c = vm.modello.fid;
            var d = vm.modello.des;
            
            var parameters = {};
            parameters.override = {modello: m, categoria: c, descrizioneModello: d}
            parameters.functionName = "load";
            vm.$emit('forward', parameters);
        },
        init: function(){
           
            var nodes;
            var vm = this;
            var l = this.$root.getItem("lang") ? this.$root.getItem("lang") : "ITA";
            new Promise(function(resolve, reject) { 
                vm.$nextTick(function(){
                    // senza promise e nextTick il rendering si incantava, bello fare il programmatore
                    nodes = vm.nodes_coll.find({'cac': Number(vm.catalogo)});
                    nodes.forEach((elem) => {
                        if(vm.categories.indexOf(elem.fid) == -1){
                            // categories rimane solo per fare da indice
                            var desc = elem.fid; //se qualche record non esiste o c'è un errore qualsiasi nel fetching, al posto della descrizione inserisco il codice
                            var isCategory = true, //false
                                isFpr = false;
                            try {
                                var prodotto = vm.products_coll.find({'pid': elem.fid, 'cac': Number(vm.catalogo)})[0]
                                if(prodotto.ity && prodotto.ity == 'category'){
                                    //mostro il modello solo se il prodotto corrispondente ha come internal type (ity) "category"
                                    isCategory = true;
                                }
                                if(prodotto.fpr){
                                    //mostro il modello solo se il prodotto corrispondente non è fuori produzione
                                    isFpr = true;
                                }
                                desc = vm.trans_coll.find({"pn": "des", "tid": prodotto.des, "lid": l, "cac": Number(vm.catalogo)})[0].txt
                            } catch(err) {
                                console.log(err)
                            }
                            if(isCategory && !isFpr){ //mostro solo se è di tipo interno category E non è fuori produzione
                                vm.categoriesObjects.push({
                                    fid: elem.fid,
                                    sid: elem.sid,
                                    des: desc
                                })
                                vm.categories.push(elem.fid)
                            }
                        }
                    })
                    vm.modelsView = vm.nodes_coll.addDynamicView('catalog_models');
                    vm.modelsView.applyFind({ 'fid' : { '$in' : vm.categories }});
                    var singleCategoryTransform = [
                        {
                            type: 'find',
                            value: {
                                'fid': '[%lktxp]category'
                            }
                        }
                    ];
                    if(!vm.nodes_coll.getTransform('singleCategoryTransform')){
                        vm.nodes_coll.addTransform('singleCategoryTransform', singleCategoryTransform);
                    }
                    //this.models = vm.modelsView.data({forceClones: true});
                    this.fetchTranslations();
                    resolve();
                })

            }).then((res) => {
                console.log(vm.categories)
                console.log(vm.models)
                vm.loading = false;
            })
        },
        fetchTranslations: function(){
            // i record dei modelli sono senza traduzioni, clonati ogni volta dalla dynamic view
            var l = this.$root.getItem("lang") ? this.$root.getItem("lang") : "ITA";
            for(var i = 0; i < this.models.length; i++){
                // per ogni record nei modelli
                var modello = this.models[i];
                // se non ho già un oggetto di traduzioni per il prodotto
                if(!this.modelsTranslation[modello.sid]){
                    // creo l'oggetto vuoto
                    this.modelsTranslation[modello.sid] = {}
                }
                // se non ho già la descrizione in lingua del prodotto
                if(!this.modelsTranslation[modello.sid][l]){
                    // eseguo le query sulle collezioni dei mei models
                    this.modelsTranslation[modello.sid][l] = this.getModelTranslation(modello.sid, l)
                }
                this.models[i]["des"] = this.modelsTranslation[modello.sid][l];
                
            }
            /* models translations 
                {
                    "FIDL-sFUD-askd-IDProd": { "ITA": "Prodotto in italiano"},
                    "...": {...}
                }
            */
        },
        getModelTranslation: function(pid, l){
            var desc = pid; // replica logica traduzione categorie
            try {
                var iddes = this.products_coll.find({'pid': pid, 'cac': Number(this.catalogo)})[0].des;
                desc = this.trans_coll.find({"pn": "des", "tid": iddes, "lid": l, "cac": Number(this.catalogo)})[0].txt
            } catch(err) {
                console.log(err)
            }
            return desc;
        }
    }
}

</script>
<style>
</style>




// WEBPACK FOOTER //
// src/components/loader/steps/SelezioneModello.vue?25f4228f